export default __webpack_public_path__ + "static/media/fb.64148600.svg";